const push = (payload) => {
  console.log('[GTM] push called', payload);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(payload);
};

// Helpers per channel config
const buildItem = (video, index, listId, listName, locationId, category, category2) => ({
  item_name: video.title,
  item_category: category,
  item_category2: category2,
  index: index + 1,
  video_duration: video.duration,
  location_id: locationId,
  item_list_id: listId,
  item_list_name: listName,
});

// 1. view_item_list — fired on viewport entry
export const trackViewItemList = (videos, listId, listName, category, category2) => {
  
  push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id: listId,
      item_list_name: listName,
      items: videos.map((v, i) =>
        buildItem(v, i, listId, listName, 'tonton_home_widget', category, category2)
      ),
    },
  });
};

// 2. select_item — thumbnail click
export const trackSelectItem = (video, index, listId, listName, category, category2) => {
  push({
    event: 'select_item',
    ecommerce: {
      item_list_id: listId,
      item_list_name: listName,
      items: [buildItem(video, index, listId, listName, 'tonton_home_widget', category, category2)],
    },
  });
};

// 3. view_item — video autoplay started
export const trackViewItem = (video, index, listId, listName, category, category2) => {
  push({
    event: 'view_item',
    ecommerce: {
      item_list_id: listId,
      item_list_name: listName,
      items: [buildItem(video, index, listId, listName, 'tonton_klips_widget', category, category2)],
    },
  });
};

// 4. select_item (navigation) — swipe/button next/prev
export const trackAutoplayNavigation = (video, index, listId, listName, category, category2) => {
  push({
    event: 'select_item',
    ecommerce: {
      item_list_id: listId,
      item_list_name: listName,
      items: [buildItem(video, index, listId, listName, 'tonton_klips_widget', category, category2)],
    },
  });
};

// 5. navi_click — top nav filter
export const trackNaviClick = (naviCategory) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'navi_click',
    navi_category: naviCategory,
    ecommerce: null,
  });
};